import React from 'react';
import SesConferences from '../components/SesConferences';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';


function App() {
  return (
    <div className="App">
      <SesConferences />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
